import React from "react";
import Layout from "../components/layout";
import { useDispatch, useSelector } from "react-redux";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import { toast } from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DoctorForm from "../components/DoctorForm";

function ApplyDoctor() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const formatTimings = (appointmentTime) => {
    return appointmentTime.map((time) => time.format("HH:mm"));
  };

  const onFinish = async (values) => {

    try {
      console.log("Values before formatting:", values.appointmentTime); // Debugging

      dispatch(showLoading());
      const formattedTimings = formatTimings(values.appointmentTime);

  
      const response = await axios.post(
        "/api/user/apply-appointment-service",
        {
          ...values,
          userId: user._id,
          appointmentTime: formattedTimings,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(hideLoading());
      if (response.data.success) {
        toast.success(response.data.message);
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  return (
    <Layout>
      <h2 className="page-title mv">Apply Service Appointment</h2>
      <DoctorForm onFinish={onFinish} />
    </Layout>
  );
}

export default ApplyDoctor;
